import {
  DISCHARGE_SUMMARY_PATH,
  LAB_TEST_RESULTS_PATH,
  MEDREFILL_HISTORY_PATH,
  NEHR_ACCESS_HISTORY_PATH,
  PRESCRIPTION_PATH,
  RADIOLOGY_PATH,
} from './paths';

export const NON_SCROLL_TOP_PATH = [
  NEHR_ACCESS_HISTORY_PATH,
  DISCHARGE_SUMMARY_PATH,
  LAB_TEST_RESULTS_PATH,
  RADIOLOGY_PATH,
  MEDREFILL_HISTORY_PATH,
  PRESCRIPTION_PATH,
];
